.label {
  margin: 10px 0px 0px 0px;
}

.group {
  text-align: center;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkxvZ2luRm9ybS5zYXNzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7OztBQUNGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyIubGFiZWxcbiAgbWFyZ2luOiAxMHB4IDBweCAwcHggMHB4XG4uZ3JvdXBcbiAgdGV4dC1hbGlnbjogY2VudGVyXG4iXX0= */